var React = require('react');

function ReplayDemoIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M3 15.987c0-.516.031-1.025.09-1.526.562-4.751 3.69-8.721 7.958-10.483A12.835 12.835 0 0 1 16 2.987c3.863 0 7.532 1.721 10 4.693V4h2v8h-8v-2h5.22a11.01 11.01 0 0 0-8.178-4.951l-.058-.006a11.422 11.422 0 0 0-1.899-.005C9.498 5.506 5.041 10.229 5 15.921V16c0 6.071 4.929 11 11 11s11-4.929 11-11h2c0 7.175-5.825 13-13 13S3 23.175 3 16v-.013Z","key":0}),React.createElement("path",{"d":"M12 10v12h2l8-6-8-6h-2Z","key":1})]);
}

ReplayDemoIcon.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 32 32"};

module.exports = ReplayDemoIcon;

ReplayDemoIcon.default = ReplayDemoIcon;
